import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from '../locales/de/translation.json';
import en from '../locales/en/translation.json';
import es from '../locales/es/translation.json';
import fr from '../locales/fr/translation.json';
import it from '../locales/it/translation.json';
import ja from '../locales/ja/translation.json';

import {
  i18n as uiExportJiraLocale,
  supportedLocales as uiExportJiraSupportedLocales
} from '@deque/ui-export-jira';
import {
  i18n as uiIssuesLocale,
  supportedLocales as uiIssuesSupportedLocales
} from '@deque/ui-issues';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    /**
     * This is where translations go. Example:
     *
     * ```
     * resources: {
     *   en: { translation: { "Hello world": "Hello world" } },
     *   es: { translation: { "Hello world": "Hola el mundo" } }
     * }
     * ```
     */
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es },
      de: { translation: de },
      it: { translation: it },
      ja: { translation: ja }
    },
    lng: 'en',
    interpolation: {
      escapeValue: false // react is already xss-safe
    },
    nsSeparator: false,
    returnEmptyString: false,
    keySeparator: false,
    react: {
      transKeepBasicHtmlNodesFor: ['strong']
    }
  });

async function loadUiExportJiraPackageTranslations() {
  for (const supportedLocale of uiExportJiraSupportedLocales) {
    const locale = await import(
      `@deque/ui-export-jira/locales/${supportedLocale}.json`
    );

    const { defaultNS } = uiExportJiraLocale.options;
    const namespace =
      (Array.isArray(defaultNS) ? defaultNS[0] : defaultNS) || '';

    uiExportJiraLocale.addResourceBundle(
      supportedLocale,
      namespace,
      locale,
      true,
      true
    );
  }
}

async function loadUiIssuesPackageTranslations() {
  for (const supportedLocale of uiIssuesSupportedLocales) {
    const locale = await import(
      `@deque/ui-issues/locales/${supportedLocale}.json`
    );

    uiIssuesLocale.addResourceBundle(
      supportedLocale,
      uiIssuesLocale.options.defaultNS || '',
      locale,
      true,
      true
    );
  }
}

loadUiExportJiraPackageTranslations();
loadUiIssuesPackageTranslations();

i18n.on('languageChanged', lang => uiExportJiraLocale.changeLanguage(lang));
i18n.on('languageChanged', lang => uiIssuesLocale.changeLanguage(lang));

export default i18n;
